package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.{TestGraph, TestGraphType}
import com.neurobs.util.{BarAxisOptions, Chart, ChartData, ChartOptions, ChartParameters, DataPoint, DataSet, LegendOptions, LineAxisOptions, ScaleLabelOptions, ScaleOptions, TickOptions, TitleOptions}
import org.scalajs.dom.html.Div
import scalatags.JsDom.all._

import scala.scalajs.js.JSConverters._
import scala.scalajs.js

object ChartView {
	def draw(g: TestGraph, divStyle: String): Div = {
		val p = new ChartParameters(
			`type` = g.`type` match {
				case TestGraphType.Bar => "bar"
				case TestGraphType.Line => "line"
			},
			data = g.`type` match {
				case TestGraphType.Bar => new ChartData(
					labels = g.x.drop(1).toJSArray,
					datasets = js.Array(new DataSet(
						label = "",
						data = g.y.drop(1).map(_.toDouble).toJSArray
					))
				)
				case TestGraphType.Line => new ChartData(
					datasets = js.Array(new DataSet(
						label = "",
						data = g.x.drop(1).zip(g.y.drop(1)).map(p => DataPoint(p._1.toDouble, p._2.toDouble)).toJSArray
					))
				)
			},
			options = new ChartOptions(
				title = new TitleOptions(display = true, text = g.title),
				legend = new LegendOptions(display = false),
				scales = g.`type` match {
					case TestGraphType.Bar => new ScaleOptions(
						xAxes = js.Array(new BarAxisOptions(scaleLabel = new ScaleLabelOptions(labelString = g.x(0)))),
						yAxes = js.Array(new BarAxisOptions(
							scaleLabel = new ScaleLabelOptions(labelString = g.y(0)),
							ticks = new TickOptions {
								override val min = 0.0
							}
						))
					)
					case TestGraphType.Line => new ScaleOptions(
						xAxes = js.Array(new LineAxisOptions(scaleLabel = new ScaleLabelOptions(labelString = g.x(0)))),
						yAxes = js.Array(new LineAxisOptions(scaleLabel = new ScaleLabelOptions(labelString = g.y(0))))
					)
				}
			)
		)
		//println(js.Dynamic.global.JSON.stringify(p))

		val can = canvas.render
		val d = div(style := divStyle, can).render
		new Chart(can.getContext(contextId = "2d"), p)
		d
	}
}
